import request from '@/config/request'

export function getCode(params){
    return request.post('/commonserver/sms/sendVerificationCode',params)
}

export function loginPhone(params){
    return request.post('/oauthserver/login/loginByVerificationCode',params)
}

export function loginUser(params){
    return request.post('/oauthserver/login/loginByAccountPassword',params)
}

export function getVerifyCode(phone){
    return request.get(`/commonserver/slider/captcha/getCode?mobile=${phone}`)
}

export function getLoginUrl(url){
    const redirectUrl = url ? url : window.location.href
    return request.get('/oauthserver/login/buildQrConnectUrl?redirectUrl=' + redirectUrl)
}

export function loginByWx(params){
    return request.post('/oauthserver/login/loginByWxMp', params)
}

export function bindPhone(params){
    return request.post('/oauthserver/login/bindPhone', params)
}